<template>
  <div
    class="animate-pulse bg-theme-surface-raised dark:bg-theme-surface-raised rounded"
    :class="sizeClasses"
    :style="customStyle"
  />
</template>

<script setup>
/* eslint-disable no-undef */
import { computed } from 'vue'

const props = defineProps({
  width: {
    type: String,
    default: '100px'
  },
  height: {
    type: String,
    default: '16px'
  },
  variant: {
    type: String,
    default: 'text',
    validator: (value) => ['text', 'circle', 'rectangle'].includes(value)
  }
})

const sizeClasses = computed(() => {
  if (props.variant === 'circle') {
    return 'rounded-full'
  }
  return 'rounded'
})

const customStyle = computed(() => ({
  width: props.width,
  height: props.height,
  minWidth: props.width,
  minHeight: props.height
}))
</script>
